<template>
    <div class="single-product__size-guide" data-index="1">
        <div class="single-product__size-guide-container">
            <a class="single-product__size-guide--btn" @click="show_guide__popup">Bangle Size Guide</a><img alt="alert-info" src="/single-product/alert-info-icon.webp">
        </div>
        <div class="size-guide__popup" ref="popupRef" id="size-guide__popup-1" :class="open ? 'active' : ''">
            <div class="size-guide__content" ref="contentRef">
                <h4 class="size-guide__heading">Bangle Size Guide</h4>
                <div class="size-guide__tab-panel">
                    <span data-tab="size-chart" class="size-guide__tab size-guide__tab--size-chart" :class="{ 'active-tab': currentTab === 'size' }" @click="handleBangleTab('size')">Size Chart</span>
                    <span data-tab="guide" class="size-guide__tab size-guide__tab--guide" :class="{ 'active-tab': currentTab === 'measurement' }" @click="handleBangleTab('measurement')">Measurement Guide</span>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'size' }">
                    <div class="size-guide__size-chart">
                        <table>
                            <tbody>
                                <tr v-for="(row, rowIndex) in bangleSizes" :key="rowIndex">
                                    <td v-for="(cell, cellIndex) in row" :key="cellIndex">
                                    {{ cell }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="size-guide__size-chart--text">
                        This bangle size guide provides a general guideline, and personal fit preference may affect your final choice. For reference, an average Asian woman typically wears a size 5.2cm bangle, while an average man might wear 5.8cm one.
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--guide" :class="{ 'active-tab': currentTab === 'measurement' }">
                    <div class="ring-size__tab-content ring-size__tab-content--find-ring-size">
                        <h4>How Do I Find My Bangle Size?</h4>
                        <div class="size-guide__method-title"><span>Method 1:</span><span> Measure your own hand</span></div>
                        <img src="/single-product/bangle-size-1.webp" data-original_src="/single-product/bangle-size-1.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>To measure the hand, position it as though putting on a bangle (tuck your thumb into the palm of your hand).</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 2</h4>
                            <span>Using a strip of paper or tape measurements, wrap it around your hand at the widest point. If you are using a plain strip of paper, mark your size with a pen on that paper. Then measure that paper strip with a ruler. That would be the circumference of your hand.</span>
                        </div>
                        <div class="size-guide__step">
                            <h4>Step 3</h4>
                            <span>Cross refer the measurement to the bangle size chart and find the closest size.</span>
                        </div>
                        <div class="size-guide__method-title"><span>Method 2:</span><span> Measure your own bangle</span></div>
                        <img src="/single-product/bangle-size-2.webp" data-original_src="/single-product/bangle-size-2.webp" class="size-guide__image" alt="ring-size-guide-img">
                        <div class="size-guide__step">
                            <h4>Step 1</h4>
                            <span>If you already have a bangle, please measure the inside diameter and compare with our measurement chart.</span>
                        </div>
                    </div>
                </div>
                <div class="size-guide__footer">
                    <a @click="close_guide__popup" class="size-guide__close"><span>Continue Shopping</span></a>
                </div>
                <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
</style>

<script setup lang="ts">
const currentTab = ref('size');
    const bangleSizes = ref([
        ["Size", "Bangle Inner Diameter (CM)", "Wrist Circumference (CM)"],
        ["Small", "5.0 - 5.3", "15.0 - 15.8"],
        ["Medium", "5.4 - 5.6", "15.8 - 16.5"],
        ["Large", "5.7 - 5.8", "16.5 - 17.5"],
        ["Extra Large", "5.9 - 6.0", "17.5 - 18.5"]
    ]);
    const open = ref(false)
    const show_guide__popup = () =>{
        currentTab.value = 'size';
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 500);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }
    const popupRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);
    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };
    const handleBangleTab = (tab: string) => {
        currentTab.value = tab;
    }
</script>